/* @flow */

import formatarReal from './formatar-real';

const formatarRealOuNull = (numero: string | number | null): ?string => (
    numero ? formatarReal(numero) : null
);

export default formatarRealOuNull;
